import React, { Fragment, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import PrivateRoute from "./Auth/PrivateRoute";
import PageLayout from "../components/layout/PageLayout";
import Auth from "../pages/Auth";
import Connecting from "../pages/Connecting";

import {
  ROOT,
  FORECAST_REPORT,
  BEST_SELLERS,
  OVERSTOCK,
  AUTH,
  ONBOARDING,
  PROFILE,
  ERROR,
  CONNECTING,
  HELP,
  SHOP_REDIRECT,
  PRIVACY,
  TERMS,
  CHATBOT,
  UPGRADE_BILLING_PLAN,
  INCOMING_INVENTORY,
  IMPORT_INCOMING_INVENTORY,
  LEGACY_IMPORT_INCOMING_INVENTORY,
} from "./CONSTANTS";
import Billingplan from "../components/billing/Billingplan";

const Account = React.lazy(() => import("../pages/Account"));
const Dashboard = React.lazy(() => import("../pages/Dashboard"));
const Forecasting = React.lazy(() => import("../pages/Forecasting"));
const Help = React.lazy(() => import("../pages/Help"));
const Errorpage = React.lazy(() => import("../pages/Errorpage"));
const Onboarding = React.lazy(() => import("../pages/Onboarding"));
const PrivacyPolicy = React.lazy(() => import("../pages/PrivacyPolicy"));
const Terms = React.lazy(() => import("../pages/Terms"));
const IncomingInventory = React.lazy(() =>
  import("../pages/IncomingInventory")
);
const AddIncomingInventory = React.lazy(() =>
  import("../pages/AddIncomingInventory")
);
const ShopRedirect = React.lazy(() => import("../pages/ShopRedirect"));
const ChatbotPage = React.lazy(() => import("../pages/ChatbotPage"));

// import Account from "../pages/Account";
// import Forecasting from "../pages/Forecasting";
// import Help from "../pages/Help";
// import Errorpage from "../pages/Errorpage";
// import Onboarding from "../pages/Onboarding";
// import PrivacyPolicy from "../pages/PrivacyPolicy";
// import Terms from "../pages/Terms";

const RouterConfig = ({ noActiveSubscription }) => {
  return (
    <Fragment>
      <Suspense fallback={<div id="cover-spin" />}>
        <Switch>
          <Route path={PRIVACY}>
            <PrivacyPolicy />
          </Route>
          <Route path={TERMS}>
            <Terms />
          </Route>

          <Route
            exact
            path="/chatbot"
            render={({ location }) => (
              <Redirect
                to={{
                  pathname: CHATBOT,
                  search: location.search,
                  hash: location.hash,
                }}
              />
            )}
          />

          <PrivateRoute path={CHATBOT}>
            <ChatbotPage />
          </PrivateRoute>

          <PrivateRoute path={ONBOARDING}>
            <Onboarding />
          </PrivateRoute>

          <PrivateRoute path={UPGRADE_BILLING_PLAN}>
            <Billingplan />
          </PrivateRoute>

          <Route path={ERROR}>
            <Errorpage />
          </Route>

          <Route path={AUTH}>
            <Auth />
          </Route>

          <Route path={CONNECTING}>
            <Connecting />
          </Route>

          {/*
           * Old add-page URL. Send it to the child path so App Bridge
           * keeps Incoming Inventory active.
           * Example: /ui/incominginventoryadd?shop=… → /ui/incominginventory/add?shop=…
           */}
          <Route
            exact
            path={LEGACY_IMPORT_INCOMING_INVENTORY}
            render={({ location }) => (
              <Redirect
                to={{
                  pathname: IMPORT_INCOMING_INVENTORY,
                  search: location.search,
                  hash: location.hash,
                }}
              />
            )}
          />

          {/*
            While a shop has no active subscription, NoActiveSubscriptionModal
            blocks the whole UI with an overlay — but these routed pages would
            still mount underneath it and fire all their data-fetching effects
            (e.g. Forecasting's report data) for nothing. Render null instead
            so cancelled shops don't trigger that background work until they
            pick a plan again.
          */}
          <PageLayout>
            <PrivateRoute path={ROOT} exact>
              {noActiveSubscription ? null : <Dashboard />}
            </PrivateRoute>
            <PrivateRoute path={FORECAST_REPORT} exact>
              {noActiveSubscription ? null : <Forecasting />}
            </PrivateRoute>
            <PrivateRoute path={BEST_SELLERS} exact>
              {noActiveSubscription ? null : <Forecasting />}
            </PrivateRoute>
            <PrivateRoute path={OVERSTOCK} exact>
              {noActiveSubscription ? null : <Forecasting />}
            </PrivateRoute>
            {/* <PrivateRoute path={FORECASTING}>
            <Forecasting />
          </PrivateRoute> */}
            <PrivateRoute path={PROFILE}>
              {noActiveSubscription ? null : <Account />}
            </PrivateRoute>
            <Route path={HELP}>
              <Help />
            </Route>
            <Route path={SHOP_REDIRECT}>
              <ShopRedirect />
            </Route>
            {/*
             * exact so /ui/incominginventory/add does not also mount the list.
             * Without it both pages render, because this path is a prefix.
             */}
            <PrivateRoute path={INCOMING_INVENTORY} exact>
              {noActiveSubscription ? null : <IncomingInventory />}
            </PrivateRoute>
            <PrivateRoute path={IMPORT_INCOMING_INVENTORY}>
              {noActiveSubscription ? null : <AddIncomingInventory />}
            </PrivateRoute>
          </PageLayout>
        </Switch>
      </Suspense>
    </Fragment>
  );
};

export default RouterConfig;
